import React, { useCallback, useMemo } from 'react'
import { useInstData } from 'tyan/public/hooks'

const illegleReg = /\\|\/|\:|\*|\?|\"|\<|\>|\|/

const RenameFile = ({ data, showBody: Body, onSave, onClose, sortField, expansion, editFields, isTooltip }) => {
	const { me } = useInstData(null, useMemo(() => ({ state: { initValues: data, changedValues: {} } }), []))

	me.state.initValues = data

	const handleSave = useCallback(() => {
		// TODO： 检查数据要素
		if (Tyan.utility.getFormValue(me, '', 'FileName').search(illegleReg) >= 0) {
			Tyan.pubForm.showError('文件名称不可包含字符 \\/:*?"<>|')
			return
		}
		onSave(me.state.changedValues)
		onClose()
	}, [onSave, onClose])

	const handleClose = useCallback(() => {
		onClose()
	}, [onClose])

	const canSave = useCallback(() => {
		return Tyan.utility.hasChangedValues(me) && Tyan.utility.getFormValue(me, '', 'FileName')
	}, [])

	const fieldset = useMemo(() => {
		let ret = editFields
			|| ([
				{ _text: '文件名称', name: 'FileName', prompt: '不可包含字符 \\/:*?"<>|' }
			].concat(sortField
				? { _int: '排序', name: sortField, textAlign: 'left', /* minWidth: '200px', maxWidth: '200px' */ }
				: []
			).concat(expansion || []))
		isTooltip && (ret = ret.map(({ _text, ...o }) => _text ? { _html: _text, ...o } : { ...o, disabled: true }))

		return ret
	}, [sortField, isTooltip])

	return <Body data={me} maxWidth={450} isTooltip={isTooltip}
		controls={[
			{ _button: '确定', icon: 'save', handler: handleSave, disabled: !canSave() },
			{ _button: '取消', icon: 'close', handler: handleClose },
		]}
		fieldsets={
			[
				{ title: '', _fieldset: fieldset, minWidth: '100px' }
			]
		}
	/>
}


export default RenameFile